export default function PageJsonLd() {
  const baseUrl = 'https://business-training.by';
  const pageUrl = `${baseUrl}/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie`;

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: { '@id': baseUrl, name: 'Главная' } },
      { '@type': 'ListItem', position: 2, name: 'Энциклопедия корпоративного обучения', item: { '@id': `${baseUrl}/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie`, name: 'Энциклопедия корпоративного обучения' } },
      { '@type': 'ListItem', position: 3, name: 'Командообразование сотрудников', item: { '@id': pageUrl, name: 'Командообразование сотрудников' } },
    ],
  };

  const service = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Командообразование сотрудников',
    description:
      'Корпоративное командообразование и тимбилдинг для бизнеса. Бизнес-игры, фасилитация, стратегические сессии и развитие командной работы сотрудников.',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      jobTitle: 'Бизнес-тренер',
      url: baseUrl,
    },
    areaServed: { '@type': 'Place', name: 'Беларусь, Россия, Казахстан, Израиль' },
    serviceType: 'Корпоративное обучение и развитие команд',
    url: pageUrl,
  };

  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер',
    description:
      'Практикующий бизнес-тренер с 18+ лет опыта. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников. Компании Беларуси, России, Казахстана и Израиля.',
    url: baseUrl,
    sameAs: [
      'https://www.linkedin.com/in/sivko-trainer',
      'https://www.instagram.com/sivko_trainer',
    ],
    knowsAbout: [
      'Командообразование',
      'Тимбилдинг',
      'Корпоративное обучение',
      'Развитие команд',
      'Бизнес-игры',
      'Фасилитация',
    ],
  };

  const faqQuestions = [
    {
      '@type': 'Question',
      name: 'Что такое командообразование?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Командообразование — это системная работа по развитию доверия, коммуникации, ответственности и эффективности внутри команды. В отличие от развлекательного тимбилдинга, командообразование направлено на реальные бизнес-результаты.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что такое тимбилдинг?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Тимбилдинг (team building) — это мероприятия, направленные на сплочение коллектива, развитие командного духа и улучшение взаимодействия между сотрудниками.',
      },
    },
    {
      '@type': 'Question',
      name: 'Чем отличается тимбилдинг от командообразования?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Тимбилдинг — это чаще развлекательные мероприятия (квесты, пейнтбол, боулинг). Командообразование — это системная работа, которая меняет отношения, правила взаимодействия, ценности и культуру команды.',
      },
    },
    {
      '@type': 'Question',
      name: 'Когда компании нужен тимбилдинг?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Тимбилдинг нужен при росте компании, слиянии команд, высокой текучести, конфликтах между отделами, низкой вовлеченности и при необходимости внедрения изменений.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как проходит корпоративное командообразование?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Процесс включает диагностику, постановку целей, подготовку программы, проведение тренинга или бизнес-игры, разбор результатов, план внедрения и поддержку.',
      },
    },
    {
      '@type': 'Question',
      name: 'Сколько длится программа командообразования?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Однодневный тренинг — 6-8 часов. Комплексная программа — от 1 до 3 месяцев с несколькими модулями и сопровождением.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что лучше — бизнес-игра или тренинг?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Бизнес-игры лучше для быстрого сплочения и выявления скрытых проблем. Тренинги лучше для системного развития навыков. Часто оптимален комбинированный формат.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли провести командообразование онлайн?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, онлайн-формат работает для распределенных команд. Используются виртуальные бизнес-игры, фасилитация и командные проекты.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как оценить результат командообразования?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Результаты измеряются по коммуникации, вовлеченности, текучести, скорости решения задач и бизнес-показателям. Диагностика проводится до и после программы.',
      },
    },
    {
      '@type': 'Question',
      name: 'Для каких компаний подходит командообразование?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Компании от 20 до 1000+ сотрудников: производство, ритейл, IT, банки, логистика, медицина и другие отрасли.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что получают руководители от командообразования?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Руководители получают сильную команду, которая самостоятельно решает задачи, меньше конфликтует, быстрее адаптируется к изменениям и берет ответственность.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как заказать программу командообразования?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Заполните заявку на сайте или свяжитесь по телефону. Мы проведем диагностику, определим цели и подготовим программу под задачи вашей компании.',
      },
    },
  ];

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqQuestions,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(service)}</script>
      <script type="application/ld+json">{JSON.stringify(person)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </>
  );
}